import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row q-col-gutter-lg" }
const _hoisted_2 = {
  key: 0,
  class: "col-12"
}

import {PropType} from 'vue';
import {Business} from 'src/models/business.model';
import BusinessServiceTable from 'src/apps/business/components/BusinessServiceTable.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceTabPanel',
  props: {
  business: {
    type: Object as PropType<Business>,
    required: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (__props.business.services?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(BusinessServiceTable, { business: __props.business }, null, 8, ["business"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})